<template>
  <div v-cloak>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'soporte-online' }">{{
                $t("soporteOnline")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("soporteOnlineDetails") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6">
              <h5>Ticket #{{ idTicket }}</h5>
              <p id="subject">
                <strong>{{ subject }}</strong>
              </p>
            </div>
            <div class="col-md-6" align="right">
              {{ dateCab | parseDateMin }}
              <span class="badge badge-success" v-if="status === 0">{{
                $t("abierto")
              }}</span>
              <span class="badge badge-warning" v-else-if="status === 1">{{
                $t("esperandoRespuesta")
              }}</span>
              <span class="badge badge-primary" v-else-if="status === 2">{{
                $t("respondido")
              }}</span>
              <span class="badge badge-secondary" v-else-if="status === 3">{{
                $t("cerrado")
              }}</span>
              <span class="badge badge-danger" style="background-color: #BC9CB0"  v-else-if="status === 5">{{
                $t("propuestoParaCierre")
              }}</span>
            </div>
            <div class="col-md-12">
              <button @click="openModal()" class="btn btn-primary">
                {{$t('responder')}}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" v-for="ticket in listTickets">
        <div style="margin-top:5px" id="containerTicket">
          <div class="panel panel-ticket" v-if="ticket.visita === 0">
            <div
              :class="{
                'panel-heading-admin': !ticket.detTickets.isAdmin,
                'panel-heading': ticket.detTickets.isAdmin,
              }"
            >
              <p
                style=" margin-bottom: 0px; height: 2.5rem;"
                class="panel-title"
              >
                <!--                                <img style="width: 50px; padding-right: 10px;" :src="ticket.creador.imageURL"-->
                <!--                                     v-if="ticket.creador.imageURL">-->
                <strong>
                  <span v-if="!ticket.detTickets.isAdmin"
                    >{{ ticket.creador.name }} {{ ticket.creador.surName }} ||
                    {{$t('cliente')}}</span
                  >
                  <span v-else>
                    <span v-if="ticket.creador.deparment === 1">{{$t('comercial')}}</span>
                    <span v-else-if="ticket.creador.deparment === 2"
                      >{{$t('administracion')}}</span
                    >
                    <span v-else-if="ticket.creador.deparment === 3"
                      >{{$t('tecnico')}}</span
                    >
                    <span v-else>{{$t('soporteTecnico')}}</span>
                  </span>
                  <span style="float:right;">{{
                    ticket.detTickets.date | parseDateMin
                  }}</span>
                </strong>
              </p>
            </div>
            <div class="panel-body">
              <p v-html="ticket.detTickets.message"></p>
            </div>
          </div>
          <div class="panel panel-ticket" v-if="ticket.visita === 1">
            <div class="panel-heading-visita">
              <p style="margin-bottom: 0px" class="panel-title">
                <strong
                  >{{ ticket.subject }}

                  <span style="float:right;">{{
                    ticket.date | parseDateMin
                  }}</span>
                </strong>
              </p>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-3">
                  <p>
                    <strong>{{$t('tecnico')}}</strong> {{ ticket.name }}
                    {{ ticket.surname }}
                  </p>
                </div>
                <div class="col-md-3">
                  <p><strong>{{$t('horaInicioMayusculas')}}:</strong> {{ ticket.hora_inicio }}</p>
                </div>
                <div class="col-md-3">
                  <p><strong>{{$t('horaFinal')}}:</strong> {{ ticket.hora_final }}</p>
                </div>
                <div class="col-md-3">
                  <p>
                    <strong>{{$t('personaDeContacto')}}:</strong> {{ ticket.contact }}
                  </p>
                </div>
                <div class="col-md-3">
                  <p><strong>{{$t('motivoVisita')}}:</strong> {{ ticket.subject }}</p>
                </div>
                <div class="col-md-3">
                  <p>
                    <strong>{{$t('servicioBajoMantenimiento')}}:</strong
                    ><span v-if="ticket.mantenimiento"> {{$t('siMayuscula')}}</span
                    ><span v-else> {{$t('noMayuscula')}}</span>
                  </p>
                </div>
                <div class="col-md-3">
                  <p>
                    <strong>{{$t('desplazamiento')}}:</strong
                    ><span v-if="ticket.desplazamiento"> {{$t('siMayuscula')}}</span
                    ><span v-else> {{$t('noMayuscula')}}</span>
                  </p>
                </div>
                <div class="col-md-12">
                  <strong>{{$t('descripcion')}}:</strong>
                  <p v-html="ticket.description"></p>
                </div>

                <div class="col-md-4">
                  <a
                    :href="'../tickets/firmas/' + ticket.id + '.png'"
                    target="_blank"
                    class="thumbnail"
                  >
                    <img
                      width="50%"
                      :src="'../tickets/firmas/' + ticket.id + '.png'"
                      class="fancy"
                    />
                  </a>
                </div>
                <div class="col-md-4" v-for="p in ticket.photos">
                  <img
                    width="50%"
                    :src="'../tickets/fotos/' + ticket.id + '/' + p.name"
                    class="fancy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal
        name="respuestaTicket"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h5 style="margin: 0px">{{ $t("responderTicket") }}</h5>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <label
                ><strong> {{ $t("mensaje") }}</strong></label
              >
              <textarea
                type="text"
                v-model="ticket.mensaje"
                style="height: 300px"
                class="form-control"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button @click="cerrarModal()" class="btn btn-default">
                <i class="fa fa-times-circle"></i>
                {{ $t("cerrar") }}
              </button>
              <button class="btn btn-primary" @click="nuevoTicket()">
                <i class="fa fa-paper-plane"></i>
                {{ $t("enviarTicket") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal
        name="propuestaCierreTicket"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="false"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px; text-align: center">{{ $t("propuestaDeCierreDeTicket") }}</h4>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <h5>{{ $t("esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo") }}</h5>
              <p v-if="ultimaRespuesta">{{ $t("ultimaRespuestaDelEquipoTecnico") }}:</p>
              <template style="margin-top:5px" id="containerTicketModal" class="col-12" v-if="ultimaRespuesta">
                <div class="panel panel-ticket">
                  <div
                    :class="{
                      'panel-heading-admin': !ultimaRespuesta.detTickets.isAdmin,
                      'panel-heading': ultimaRespuesta.detTickets.isAdmin,
                    }"
                  >
                    <p
                      style=" margin-bottom: 0px; height: 2.5rem;"
                      class="panel-title"
                    >
                      <strong>
                        <span v-if="!ultimaRespuesta.detTickets.isAdmin"
                          >{{ ultimaRespuesta.creador.name }} {{ ultimaRespuesta.creador.surName }} ||
                          {{$t('cliente')}}</span
                        >
                        <span v-else>
                          <span v-if="ultimaRespuesta.creador.deparment === 1">{{$t('comercial')}}</span>
                          <span v-else-if="ultimaRespuesta.creador.deparment === 2"
                            >{{$t('administracion')}}</span
                          >
                          <span v-else-if="ultimaRespuesta.creador.deparment === 3"
                            >{{$t('tecnico')}}</span
                          >
                          <span v-else>{{$t('soporteTecnico')}}</span>
                        </span>
                        <span style="float:right;">{{
                          ultimaRespuesta.detTickets.date | parseDateMin
                        }}</span>
                      </strong>
                    </p>
                  </div>
                  <div class="panel-body">
                    <p v-html="ultimaRespuesta.detTickets.message"></p>
                  </div>
                </div>
              </template>
              <div v-if="verTextoModalPropuesta==true">
                <label>
                  <strong> {{ $t("escribaAquiSuRespuesta") }}:</strong>
                </label>
                <textarea
                  type="text"
                  v-model="ticket.mensaje"
                  style="height: 300px"
                  class="form-control"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button v-if="verTextoModalPropuesta==false" @click="verTextoModalPropuesta=true" class="btn btn-secondary">
                <i class="fa fa-times-circle"></i>
                {{ $t("noEstoyDeAcuerdo") }}
              </button>
              <button v-else @click="nuevoTicket()" class="btn btn-primary">
                 <i class="fa fa-paper-plane"></i>
                {{ $t("enviarRespuesta") }}
              </button>
              <button class="btn btn-success" @click="cerrarTicket()">
                <i class="fa fa-check"></i>
                {{ $t("siCerrarTicket") }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";

export default {
  created() {
    this.$store.dispatch("setNameRoute", "Soporte Online");
    this.getTickets();
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  data() {
    return {
      listTickets: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
      idBusiness: this.$route.params.idBusiness,
      idTicket: this.$route.params.idTicket,
      ticket: {
        mensaje: "",
      },
      dateCab: "",
      status: 0,
      subject: "",
      ultimaRespuesta: false,
      verTextoModalPropuesta: false,
    };
  },
  methods: {
    nuevoTicket() {
      if (this.ticket.mensaje === "") {
        swal({
          title: this.$t('atencion'),
          text: this.$t('elMensajeEsObligatorio'),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idTicket: this.idTicket,
          ticket: this.ticket,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "newTicketDetByTicketCab";
        this.axios
          .post(
            this.$store.getters.apiUrl + "tickets/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response) {
              vm.$notify({
                message: vm.$t('ticketEnviadoCorrectamente'),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.$modal.hide("respuestaTicket");
              vm.$modal.hide("propuestaCierreTicket");
              vm.ticket.mensaje = "";

              vm.getTickets();
            } else {
              swal({
                title: vm.$t('atencion'),
                text: response,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    openModal() {
      this.$modal.show("respuestaTicket");
    },
    openModalPropuestaCierre() {
      this.$modal.show("propuestaCierreTicket");
    },
    cerrarModal() {
      this.$modal.hide("respuestaTicket");
    },
    cerrarModalPropuestaCierre() {
      this.$modal.hide("propuestaCierreTicket");
    },
    cerrarTicket() {
      const controller = "changeStatusTicket";
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idTicket: this.idTicket,
        estado: 3,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "tickets/" + controller, params, config)
        .then(function(response) {
          if (response.data.response) {
            vm.status = 3;

            vm.$modal.hide("respuestaTicket");
            vm.$modal.hide("propuestaCierreTicket");

          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTickets() {
      const controller = "getTicketsDetByTicketCab";
      var config = {
        params: {
          idTicket: this.idTicket,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "tickets/" + controller, config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTickets = response.data.result.tickets;
            vm.listTickets = vm.setImageURLs(vm.listTickets);
            vm.dateCab = response.data.result.tickets[0].dateCabs;
            vm.status = response.data.result.tickets[0].status;
            vm.subject = response.data.result.tickets[0].subject;

            if(response.data.result.tickets[0].status == 5) {
              let ultimaRespuestaAnadida = false

              vm.listTickets.forEach(ticket => {
                if(ultimaRespuestaAnadida == false) {
                  if(ticket.detTickets.isAdmin == 1) {
                    vm.ultimaRespuesta = ticket;
                    ultimaRespuestaAnadida = true;
                  }
                }
              });

              vm.$modal.show("propuestaCierreTicket");
            }

          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    setImageURLs(lista) {
      lista.forEach(function(e) {
        if (e.creador.deparment) {
          e.creador.imageURL =
            "http://www.tactilware.com/firmas/" + e.creador.name + ".png";
        }
      });

      return lista;
    },
  },
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
}

tbody td {
  padding: 0 !important;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}

.panel-ticket > .panel-heading {
  color: #ffffff;
  background-color: #363c34;
  border-color: #1d1f1c;
}

.panel-ticket > .panel-heading-admin {
  color: #ffffff;
  background-color: #428bca;
  border-color: #428bca;
}

.panel-ticket > .panel-heading-visita {
  color: #468847;
  background-color: #d6e9c6;
  border-color: #d6e9c6;
}

.panel-heading-admin {
  padding: 10px 15px;
  border-bottom: 1px solid #428bca;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.panel-heading-visita {
  color: #468847;
  padding: 10px 15px;
  border-bottom: 1px solid #d6e9c6;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid #363c34;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.panel-ticket {
  border-color: #1d1f1c;
}

.panel {
  margin-bottom: 20px;
  background-color: #ffffff;
  border: 1px solid #000;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.panel-body {
  padding: 15px;
}

#subject {
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/SoporteOnline/SoporteOnlineForm.vue